import React, { useEffect, useState } from 'react'
import CardCustom from '../custom/card-custom'
import { BsPersonFill } from 'react-icons/bs'
import { ProgressBar } from 'react-bootstrap'
import { getDashboardTypeAPI } from '../../services/dashboard'

export default function TypeEmploys() {
  const [statusEmploy, setStatusEmploy] = useState([])

  useEffect(() => {
    const getDashboardType = async () => {
      try {
        const resp = await getDashboardTypeAPI()
        if (!resp) return
        if (resp.status) {
          setStatusEmploy(resp.result)
        } else {
          setStatusEmploy([])
        }
      } catch (error) {
        setStatusEmploy([])
      }
    }
    getDashboardType()
  }, [])

  return (
    <CardCustom minHeight="none">
      <div className="p-3">
        <h5 className=" ">Employee Type </h5>
        <div className="d-flex justify-content-between">
          {statusEmploy.map((d, i) => (
            <div key={`status-${i}`}>
              <p className="small ">{d.type}</p>
              <h5 className="mb-0">
                {Math.round(
                  (d.counts /
                    statusEmploy
                      .map((d) => d.counts)
                      .reduce((a, b) => a + b, 0)) *
                    100
                )}
                %
              </h5>
              <span className="fw-light small text-muted">
                <BsPersonFill size={10} className="me-1" />
                {d.counts.toLocaleString()}
              </span>
            </div>
          ))}
        </div>
        <ProgressBar className="mt-3" style={{ height: 10 }}>
          {statusEmploy.map((d, i) => (
            <ProgressBar
              key={`progressBar-${i}`}
              // style={{
              //   color: `${i !== 0 ? '#FFD47F' : '#2C5DFE'}`
              // }}
              variant={`${i !== 0 ? 'warning' : 'primary'}`}
              now={Math.round(
                (d.counts /
                  statusEmploy
                    .map((d) => d.counts)
                    .reduce((a, b) => a + b, 0)) *
                  100
              )}
              // barStyle={{ backgroundColor: i !== 0 ? '#FFD47F' : undefined }}
            />
          ))}
        </ProgressBar>
      </div>
    </CardCustom>
  )
}
